import { render, staticRenderFns } from "./kpi-rank-detail.vue?vue&type=template&id=0d686e48&scoped=true"
import script from "./kpi-rank-detail.vue?vue&type=script&lang=js"
export * from "./kpi-rank-detail.vue?vue&type=script&lang=js"
import style0 from "./kpi-rank-detail.vue?vue&type=style&index=0&id=0d686e48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d686e48",
  null
  
)

export default component.exports